import { REACTION_DATA_UPDATE, REACTION_DATA_REMOVE, RESET_TO_DEFAULT } from '../Actions/Constants';

const initialState = {
    data: {}, // Format: { [msgId]: reactionsArray }
};

export function ReactionReducer(state = initialState, action = {}) {
    switch (action.type) {
        case REACTION_DATA_UPDATE: {
            const { msgId, reactions, lastReactionTime } = action.payload;
            return {
                ...state,
                data: {
                    ...state.data,
                    [msgId]: {
                        reactions,
                        lastReactionTime,
                    },
                },
            };
        }
        case REACTION_DATA_REMOVE: {
            const { msgId } = action.payload;
            const newData = { ...state.data };
            delete newData[msgId];
            return {
                ...state,
                data: newData,
            };
        }
        case RESET_TO_DEFAULT:
            return initialState;
        default:
            return state;
    }
}
